module.exports = {"430611001":"柳林洲街道","430611101":"广兴洲镇","430611102":"许市镇","430611103":"钱粮湖镇","430611104":"良心堡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430611.json
// module id = 1862
// module chunks = 0